<template>
  <div class="x3-contract-detail"
    :class="{ rotate: hasRotate == 1, 'no-rotate': hasRotate == 2 }">
    <div class="preview-content" :class="{ 'bt': (renderData && renderData.status == 2) }">
      <!-- 合同模板 -->
      <div id="contractContent" v-show="!isWriting"></div>
      <!-- 签署 -->
      <div class="sign-wrapper" :class="{ 'is-writing': isWriting }">
        <div id="signContent"></div>
      </div>
      <div id="writingTips" v-if="isShowWritingTips">
        <span>请横屏手写家长签署</span>
        <svg class="icon" aria-hidden="true" @click="closeTips">
          <use xlink:href="#icon-guanbi1"></use>
        </svg>
      </div>
    </div>
    <div class="preview-operate van-hairline--top"
      v-if="renderData && renderData.status == 1">
      <div class="sign-operate" v-if="isWriting">
        <van-button class="operate-item operate-default" square round size="small" @click="goBack">返回</van-button>
        <span>
          <van-button class="operate-item operate-default" square round size="small" @click="clearCanvas">清屏</van-button>
          <van-button class="operate-item" square round size="small" @click="submitSign">提交</van-button>
        </span>
      </div>
      <template v-else>
        <van-button square round disabled block class="operate-item" size="small" v-if="!isShowSign">请滑动阅读完本合同内容</van-button>
        <div v-else class="flex-between">
          <div class="operate-tips" @click="isChecked = !isChecked">
            <van-checkbox v-model="isChecked" icon-size="14px" checked-color="#FF8534"/>
            <span>我已阅读并同意本合同内容</span>
          </div>
          <van-button class="operate-item" square round size="small" @click="startSign">开始签名</van-button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Pdfh5 from 'pdfh5';
import handwriting from '@mlib/js/bundle-bg.js';
import 'pdfh5/css/pdfh5.css';

export default {
  name: 'x3-contract-detail',
  data() {
    return {
      // contractId: this.$vxRoute.query.contractId || '', // 合同模板id
      contractId: this.$route.query.contractId || '', // 合同模板id
      companyId: this.$route.query.companyId,
      isWriting: false, // 是否正在签署
      isShowWritingTips: false,
      pdfh5: null,
      canvasBoard: null,
      timer: -1,
      screenOrientation: '', // 屏幕方向
      hasRotate: 0, // 是否需要旋转
      isShowSign: false,
      isChecked: false,
      renderData: null
    };
  },
  methods: {
    startSign() {
      if(!this.isChecked){
        vant.Toast('请先同意合同内容哦。');
        return;
      }
      this.isWriting = true;
      this.isShowWritingTips = true;
      this.updateOrientation();
    },
    closeTips() {
      this.isShowWritingTips = false;
    },
    goBack() {
      this.isWriting = false;
      this.isShowWritingTips = false;
      this.updateOrientation();
    },
    clearCanvas() {
      this.canvasBoard.clear();
    },
    async submitSign() {
      if (this.canvasBoard.isEmpty()) {
        vant.Toast('您还没有签署，签署后才能提交哦~');
        return;
      }
      vant.Dialog.confirm({
        message: '提交后不能修改哦，确定提交吗？',
        confirmButtonColor: '#FF8534',
      }).then(result => {
        if (result) {
          this.showLoading();
          let baseUrl = this.canvasBoard.savePng();
          // 1.先转为blob格式  file.content是此文件的base64格式 
          let blob = this.convertBase64UrlToBlob(baseUrl);
          // 拿到文件名
          let fileName = new Date().getTime() + Math.floor((Math.random()*10000)+1)+'.png';
          // 2.再转为file类型
          let file1 = this.blobToFile(blob,fileName);
          console.log("blob:",baseUrl);
          console.log("blob:",blob);
          console.log("file1:",file1);

          xgjzt.oss.setConfig({
            max: 2,
            env: process.env.VUE_APP_x3_env,
            getStsParams: this.getOssRequest,
            isEncrypt:true,
            fileNameType:2, // 1原文件名，2随机文件名
          });

          xgjzt.oss.uploadFile({
            platform: 'h5',
              options: {
                content: blob,
                file: file1,
                config: {
                  image: {
                    compress: false,
                  },
                },
              },
          }).then(res=> {
            this.$api.contractSign({
              contractId: this.contractId,
              signFileUrl: res.url,
            }).then(res1=> {
              vant.Toast.clear();
              if (res1.code == 200) {
                vant.Toast.success('签署成功');
                this.goBack();
                this.previewContract();
              } else {
                vant.Toast.fail(res1.msg);
              }
            })
          })
        }
      });
    },
    // 获取oss文件上传签名
    getOssRequest(file) {
      let cid = this.companyId
      let fileSuffix = file.name.split('.').pop();
      
      // 如果有建议的文件名，从建议名称中提取后缀
      if (file._suggestedName) {
        const suggestedSuffix = file._suggestedName.split('.').pop();
        if (suggestedSuffix !== file._suggestedName) {
          // 确保提取到的是真正的后缀（不是整个文件名）
          fileSuffix = suggestedSuffix;
        }
      }
      
      return async function() {
        let ret = await app.http.ajax({
          method: 'post',
          url: '/cs-crm/public/common/getOssStsSign',
          params: {
            businessType: 'x3_other',
            fileName: file.name,
            fileSuffix: fileSuffix,
            fileType: "1",
            terminal: 0,
            companyId: cid
          },
        });
        let stsParams = ret.data;
        return stsParams;
      };
    },
    previewContract() { // 预览合同
      this.showLoading();
      this.$api.contractDetail({
        id: this.contractId
      }).then(res => {
        if (res.code == 200) {
          this.renderData = res.data;
          this.initPdf(this.renderData.fileUrl);
        } else {
          vant.Toast.fail(res.msg);
        }
        vant.Toast.clear();
      });
    },
    initPdf(fileUrl) { // 实例化
      this.pdfh5 = new Pdfh5('#contractContent', {
        pdfurl: fileUrl,
      });
      let _this = this;
      this.pdfh5.on('complete', function (status, msg, time) {  // 监听完成事件
        // console.log("状态：" + status + "，信息：" + msg + "，耗时：" + time + "毫秒，总页数：" + this.totalNum)
        document.querySelector('.pdfjs .backTop').remove();
        // console.log(this);
        _this.bindScollEvent();
      });
    },
    initCanvas() { // 初始化画板
      let canvas = document.getElementById('signContent');
      this.canvasBoard = new Handwriting(canvas, canvas.offsetWidth, canvas.offsetHeight, {
        lineWidth: 5,
      });
    },
    reInitCanvas() { // 重新初始化画板
      this.timer != -1 && clearTimeout(this.timer);
      this.canvasBoard = null;
      document.getElementById('signContent').innerHTML = '';
      this.timer = setTimeout(() => {
        let canvas = document.getElementById('signContent');
        this.canvasBoard = new Handwriting(canvas, canvas.offsetWidth, canvas.offsetHeight, {
          lineWidth: 5,
        });
      }, 301);
    },
    bindOrientation() { // 方向发生变化
      let _this = this;
      let supportOrientation =
        typeof window.orientation === 'number' && typeof window.onorientationchange === 'object';
      let init = function () {
        if (supportOrientation) { // 用户水平或者垂直翻转设备（即方向发生变化）时触发的事件
          window.addEventListener('orientationchange', _this.updateOrientation, false);
        } else { // 监听resize事件
          window.addEventListener('resize', _this.updateOrientation, false);
        }
      };
      init();
    },
    updateOrientation() { // 方向发生变化，触发
      setTimeout(() => {
        let sab = getComputedStyle(document.documentElement).getPropertyValue("--sab");
        let safeHeight = +sab.split('px')[0];
        let width = document.documentElement.clientWidth,
            height = document.documentElement.clientHeight - safeHeight;
        let $body = document.querySelector('.x3-contract-detail'),
          $writingTips = document.querySelector('#writingTips');
        let supportOrientation =
          typeof window.orientation === 'number' && typeof window.onorientationchange === 'object';
        if (supportOrientation) {
          switch (window.orientation) {
            case 90:
            case -90:
              this.screenOrientation = 'landscape'; // 横屏
              break;
            default:
              this.screenOrientation = 'portrait'; // 竖屏
              break;
          }
        } else {
          this.screenOrientation =
            window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
        }
        if (this.screenOrientation == 'portrait' && this.isWriting) { // 竖屏
          this.isShowWritingTips = true;
          this.hasRotate = 1;
          $body.setAttribute(
            'style',
            `width: ${height}px; height: ${width}px; top:${(height - width) / 2}px; left: ${
              0 - (height - width) / 2
            }px; transform: rotate(90deg);`
          );
          $writingTips.setAttribute('style', `top: ${parseInt((width - 150) / 2)}px;`);
        } else {
          $body.setAttribute(
            'style',
            `width: ${width}px; height: ${height}px; top: 0; left: 0; transform: none;`
          );
          this.hasRotate = 2;
          this.isShowWritingTips = false;
        }
        this.reInitCanvas();
      }, 100);
    },
    bindScollEvent(){ // 判断元素是否挂载 判断有无滚动条，有滚动条则绑定事件，
      var container =  document.querySelector('.viewerContainer');
      if(container !== null){
        if(container.scrollHeight != container.clientHeight){
          container.addEventListener('scroll', this.divScrollEv, true);
        }else{ // 没有滚动条直接处理元素显示隐藏
          this.handleElement();
        }
      }
    },
    divScrollEv() { //绑定滚动容器的事件
      var scrollHeight = document.querySelector('.viewerContainer').scrollHeight, 
      scrollTop = document.querySelector('.viewerContainer').scrollTop,
      clientHeight = document.querySelector('.viewerContainer').clientHeight;
      if (scrollHeight - clientHeight <= (scrollTop+3)) {
        this.handleElement();
      }
    },
    handleElement(){
      this.isShowSign = true;
    },
    // 先将base64转换为blob
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    // 再将blob转换为file
    blobToFile(theBlob, fileName){
      theBlob.lastModifiedDate = new Date();  // 文件最后的修改日期
      theBlob.name = fileName;                // 文件名
      return new File([theBlob], fileName, {type: theBlob.type, lastModified: Date.now()});
    }, 
    convertBase64UrlToBlob(urlData) {
      let bytes = window.atob(urlData.split(',')[1]);
      let ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (let i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ab], { type: 'image/jpeg' });
    },
  },
  mounted() {
    this.previewContract();
    // 预览合同时是不需要初始化的，后面可以优化下
    this.initCanvas();
  },
  created() {
    this.bindOrientation();
  },
};
</script>

<style lang="scss" scoped>
.x3-contract-detail {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  // display: flex;
  // flex-direction: column;
  &.rotate {
    animation: rotate 1s forwards !important;
  }
  &.no-rotate {
    animation: norotate 1s forwards !important;
  }
  .preview-content {
    // flex: 1;
    // position: relative;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 52px;
    &.bt {
      bottom: 0;
    }
    #contractContent {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
    .sign-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: #fff;
      z-index: -1;
      opacity: 0;
      &.is-writing {
        z-index: 10000;
        opacity: 1;
      }
      #signContent {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: 20px;
        border: 2px dashed #dcdfe6;
        border-radius: 3px;
        background-color: #fff;
      }
    }
    #writingTips {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      left: 100px;
      width: 150px;
      padding: 5px;
      background-color: #fffbe6;
      color: #ffbf00;
      border: 1px solid #ffe58f;
      border-radius: 3px;
      font-size: 12px;
      transform: rotate(-90deg);
      z-index: 1111;
      .icon {
        width: 12px;
        height: 12px;
        color: #909399;
      }
    }
  }
  .preview-operate {
    position: absolute;
    top: auto;
    left: 0;
    right: 0;
    bottom: 0;

    height: 52px;
    padding: calc(var(--gap) * 10) calc(var(--gap) * 12);
    text-align: right;
    background-color: #fff;
    .operate-item {
      background-color: var(--c5);
      border-color: var(--c5);
      color: var(--white);
      font-weight: 400;
      font-size:var(--fs-sm);
      line-height:var(--lh-sm);
      &.operate-default {
        margin-right: calc(var(--gap) * 10);
        background-color: #fff;
        color: #666;
        border: 1px solid #e4e7ed;
      }

    }
    .operate-tips {
      display: flex;
      color: var(--g7);
      .van-checkbox {
        margin-right: calc(var(--gap) * 5);
      }
    }
    .sign-operate {
      display: flex;
      justify-content: space-between;
    }
  }
  @keyframes rotate {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(90deg);
    }
  }
  @keyframes norotate {
    0% {
      transform: rotate(90deg);
    }
    100% {
      transform: none;
    }
  }
}
</style>